import { getFeatureFlagsPageLoader } from './getFeatureFlagsPageLoader';
import { DEFAULT_USER_FEATURE_FLAGS, UserFeatureFlags } from './types';

export function getUserFeatureFlagsPageLoader(
  anonymousID: string | undefined,
  userID: string | undefined,
): Promise<UserFeatureFlags> {
  const traits: Record<string, string> = {};

  if (userID) {
    traits.userID = userID;
  }

  if (anonymousID) {
    traits.anonymousID = anonymousID;
  }

  return getFeatureFlagsPageLoader(
    Object.keys(DEFAULT_USER_FEATURE_FLAGS) as Array<keyof UserFeatureFlags>,
    userID || anonymousID || '0',
    traits,
  );
}
